import React, { FC, MouseEventHandler, useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { FlexboxVertical } from './Layout';
import { WindowResizeHelper } from '../../utils/ResizeHelper';

const AccordionBody = styled(FlexboxVertical)<{ collapsed?: boolean, lastCollapsed?: boolean, accordionHeight?: number }>`
  overflow: hidden;
  transition: ${({ collapsed = false, lastCollapsed = false }) => collapsed === lastCollapsed ? 'none' : 'transform 300ms ease-out, opacity 150ms ease-out, margin-bottom 150ms ease-out'};
  transition-delay: ${({ collapsed = false, lastCollapsed = false }) => collapsed && !lastCollapsed ? '300ms' : '0'};
  transform-origin: top;
  transform: ${({ collapsed = false }) => collapsed ? 'scaleY(0)' : 'scaleY(1)'};
  opacity: ${({ collapsed = false }) => collapsed ? '0' : '1'};
  margin-bottom: ${({ collapsed = false, accordionHeight = 0 }) => collapsed ? `-${accordionHeight}px` : '0'};
`;

interface Props {
  collapsed: boolean;
  style?: React.CSSProperties;
  onClick?: MouseEventHandler<HTMLDivElement>;
}
export const AccordionSection: FC<Props> = ({ collapsed, children, ...props }) => {
  const accordionRef = useRef<HTMLDivElement>(null);
  const lastCollapsedStateRef = useRef<boolean>(collapsed);
  const [accordionHeight, setAccordionHeight] = useState<number>(0);

  const updateAccordionHeight = () => {
    if (accordionRef?.current && accordionRef.current.offsetHeight > 0 && accordionRef.current.offsetHeight !== accordionHeight) {
      setAccordionHeight(accordionRef.current.offsetHeight);
    }
  }

  useEffect(() => {
    updateAccordionHeight();
  });

  useEffect(() => {
    const listener = () => {
      updateAccordionHeight();
    };
    WindowResizeHelper.getInstance().addListener(listener);
    return () => {
      WindowResizeHelper.getInstance().removeListener(listener);
    }
  }, []);

  useEffect(() => {
    lastCollapsedStateRef.current = collapsed;
  }, [collapsed]);

  return (
    <AccordionBody
      ref={accordionRef}
      style={props.style}
      onClick={props.onClick}
      accordionHeight={accordionHeight}
      lastCollapsed={lastCollapsedStateRef.current}
      collapsed={collapsed}
    >
      { children }
    </AccordionBody>
  );
}
